import React, { useCallback, useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Spinner,
  Badge,
  Table,
} from "reactstrap"
import toast from "toastr"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { get_erp_client, sync_erp_client } from "helpers/backend_helper"

const isOk = res => res?.statusCode === 200 || res?.StatusCode === 200

const ErpClientDetail = () => {
  document.title = "ERP Client Detail | TenderSoftware - Flexi TracBoard"

  const { id } = useParams()
  const name = decodeURIComponent(id)

  const [client, setClient] = useState(null)
  const [loading, setLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)

  const loadClient = useCallback(async () => {
    setLoading(true)
    try {
      const res = await get_erp_client(name)
      setClient(res?.data || res?.Data || null)
    } catch (error) {
      toast.error(error?.message || "Failed to load client detail")
      setClient(null)
    } finally {
      setLoading(false)
    }
  }, [name])

  useEffect(() => {
    loadClient()
  }, [loadClient])

  const handleSync = async () => {
    setSyncLoading(true)
    try {
      const res = await sync_erp_client(name)
      if (isOk(res)) {
        toast.success(res?.message || res?.Message || "Client synced to FlexiTrac")
      } else {
        toast.error(res?.message || res?.Message || "Failed to sync client")
      }
    } catch (error) {
      toast.error(error?.message || "Failed to sync client to FlexiTrac")
    } finally {
      setSyncLoading(false)
    }
  }

  const row = (label, value) => (
    <tr>
      <th style={{ width: "30%" }}>{label}</th>
      <td>{value || value === 0 ? value : "-"}</td>
    </tr>
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title={"ERP Clients"} breadcrumbItem={"Client Detail"} />
        <Row>
          <Col lg="8">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{client?.customer_name || name}</h5>
                <div className="d-flex gap-2">
                  <Link to="/erp-clients" className="btn btn-outline-secondary btn-sm">
                    Back
                  </Link>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={handleSync}
                    disabled={syncLoading || !client}
                  >
                    {syncLoading ? (
                      <>
                        <Spinner size="sm" className="me-1" /> Syncing...
                      </>
                    ) : (
                      <>
                        <i className="mdi mdi-sync me-1" /> Sync to FlexiTrac
                      </>
                    )}
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <div className="text-center p-5">
                    <Spinner /> Loading...
                  </div>
                ) : !client ? (
                  <div className="text-center p-5 text-muted">
                    Client not found.
                  </div>
                ) : (
                  <Table bordered className="mb-0">
                    <tbody>
                      {row("Customer Name", client.customer_name)}
                      {row("ERP Id", client.name)}
                      {row("Customer Group", client.customer_group)}
                      {row("Territory", client.territory)}
                      {row("Customer Type", client.customer_type)}
                      <tr>
                        <th>Status</th>
                        <td>
                          {client.disabled === 0 || client.disabled === "0" ? (
                            <Badge color="success">Active</Badge>
                          ) : (
                            <Badge color="secondary">Disabled</Badge>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ErpClientDetail
